var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M13.3359 12.0894L15.0033 13.7567",
    stroke: "#EF2C38",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M15.0033 12.0894L13.3359 13.7567",
    stroke: "#EF2C38",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M9.33347 9.04454V6.99902",
    stroke: "#EF2C38",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M9.33379 11.4515C9.30525 11.4515 9.27791 11.4629 9.25785 11.4832C9.2378 11.5035 9.22672 11.531 9.22707 11.5595C9.22743 11.6186 9.27479 11.6665 9.33379 11.6676C9.39346 11.6676 9.44183 11.6192 9.44183 11.5595C9.44183 11.4999 9.39346 11.4515 9.33379 11.4515",
    stroke: "#EF2C38",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M14.7004 10.0121L11.5478 4.59785C11.0878 3.81146 10.2452 3.32812 9.33418 3.32812C8.42316 3.32812 7.58054 3.81146 7.1206 4.59785L3.31901 11.1192C2.89306 11.852 2.89231 12.7568 3.31707 13.4903C3.74182 14.2237 4.52697 14.6734 5.37454 14.6688H11.359",
    stroke: "#EF2C38",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.84aebd869e8da87bd2675839cf35ab3a.svg";
export { ForwardRef as ReactComponent };